// Admin API helpers — DB-driven journey stages, campaign types, flow edges, content library.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Journey stages
export const listJourneyStages   = ()             => axios.get(`${API}/journey-stages`);
export const createJourneyStage  = (data)         => axios.post(`${API}/journey-stages`, data);
export const updateJourneyStage  = (id, data)     => axios.put(`${API}/journey-stages/${id}`, data);
export const deleteJourneyStage  = (id)           => axios.delete(`${API}/journey-stages/${id}`);

// Campaign types
export const listCampaignTypes   = ()             => axios.get(`${API}/campaign-types`);
export const createCampaignType  = (data)         => axios.post(`${API}/campaign-types`, data);
export const updateCampaignType  = (id, data)     => axios.put(`${API}/campaign-types/${id}`, data);
export const deleteCampaignType  = (id)           => axios.delete(`${API}/campaign-types/${id}`);

// Flow edges
export const listFlowEdges       = ()             => axios.get(`${API}/flow-edges`);
export const createFlowEdge      = (data)         => axios.post(`${API}/flow-edges`, data);
export const deleteFlowEdge      = (id)           => axios.delete(`${API}/flow-edges/${id}`);

// Content library
export const listContents        = (params = {})  => axios.get(`${API}/campaign-contents`, { params });
export const createContent       = (data)         => axios.post(`${API}/campaign-contents`, data);
export const updateContent       = (id, data)     => axios.put(`${API}/campaign-contents/${id}`, data);
export const deleteContent       = (id)           => axios.delete(`${API}/campaign-contents/${id}`);

// Campaign row actions
export const duplicateCampaign   = (id)           => axios.post(`${API}/campaigns-data/${id}/duplicate`);
export const archiveCampaign     = (id, archived) => axios.post(`${API}/campaigns-data/${id}/archive`, { archived });
export const moveCampaignToStage = (id, stageId)  => axios.post(`${API}/campaigns-data/${id}/move`, { stage_id: stageId });
export const uploadCampaignsXlsx = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return axios.post(`${API}/campaigns-data/upload-xlsx`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Flow nodes (DB-driven campaign placement)
export const listFlowNodes      = (params = {})  => axios.get(`${API}/flow-nodes`, { params });
export const createFlowNode     = (data)         => axios.post(`${API}/flow-nodes`, data);
export const updateFlowNode     = (id, data)     => axios.put(`${API}/flow-nodes/${id}`, data);
export const deleteFlowNode     = (id)           => axios.delete(`${API}/flow-nodes/${id}`);
export const duplicateFlowNode  = (id)           => axios.post(`${API}/flow-nodes/${id}/duplicate`);
export const moveFlowNode       = (id, stageId)  => axios.post(`${API}/flow-nodes/${id}/move`, { stage_id: stageId });
export const archiveFlowNode    = (id, archived) => axios.post(`${API}/flow-nodes/${id}/archive`, { archived });
export const uploadFlowNodesCsv = (csvContent, onExisting = 'update') =>
  axios.post(`${API}/flow-nodes/upload`, { csv_content: csvContent, on_existing: onExisting });

// Creative library
export const listCreatives    = (params = {})    => axios.get(`${API}/campaign-creatives`, { params });
export const uploadCreative   = (file, { name, tags, notes } = {}) => {
  const fd = new FormData();
  fd.append('file', file);
  if (name)  fd.append('name',  name);
  if (tags)  fd.append('tags',  tags);
  if (notes) fd.append('notes', notes);
  return axios.post(`${API}/campaign-creatives/upload`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const updateCreative   = (id, data)        => axios.put(`${API}/campaign-creatives/${id}`, data);
export const replaceCreative  = (id, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return axios.post(`${API}/campaign-creatives/${id}/replace`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const archiveCreative  = (id, archived)    => axios.put(`${API}/campaign-creatives/${id}`, { status: archived ? 'archived' : 'active' });
export const deleteCreative   = (id)              => axios.delete(`${API}/campaign-creatives/${id}`);
